import * as React from "react";
import Svg, { SvgProps, Mask, Path } from "react-native-svg";
const HomeIcon = (props: any) => (
  <Svg width={23} height={22} fill="none" {...props}>
    <Mask id="a" fill="#fff">
      <Path
        fillRule="evenodd"
        d="M.128 11.001c6.107 0 11.056-4.925 11.056-11V0v.002c0 6.033 4.882 10.93 10.93 11-6.048.068-10.928 4.966-10.929 10.998 0-6.074-4.95-10.998-11.057-10.998V11Z"
        clipRule="evenodd"
      />
    </Mask>
    <Path
      fill={props.active?"rgba(192, 164, 111, 1)":"white"}
      d="M.128 11.001v-1h-1v1h1ZM11.184 0v-1h-1v1h1Zm0 0h1v-1h-1v1Zm10.93 11.001.01 1v-2l-.01 1ZM11.184 22v1h1v-1h-1Zm0 0h-1v1h1v-1ZM.128 11.002h-1v1h1v-1Zm0 .999c6.654 0 12.057-5.368 12.057-12h-2c0 5.518-4.498 10-10.057 10v2Zm12.057-12V0h-2v.001h2Zm-1 .999v-2 2Zm-1-1v.002h2V0h-2Zm0 .002c0 6.586 5.327 11.925 11.917 12l.022-2c-5.504-.063-9.94-4.52-9.94-10h-2Zm11.917 10c-6.59.074-11.916 5.413-11.917 11.998h2c0-5.479 4.435-9.936 9.94-9.999l-.023-2ZM11.185 21v2-2ZM.128 12.002c5.559 0 10.056 4.48 10.057 9.998h2c0-6.632-5.403-11.998-12.057-11.998v2Zm0 0v-2 2Zm1-1V11h-2 2Z"
      mask="url(#a)"
    />
  </Svg>
);
export default HomeIcon;
